export default __webpack_public_path__ + "static/media/blog-img238.dfa3dbeb.jpg";